import { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

// Bumpear el sufijo del STORAGE_KEY invalida flags viejas (visitantes que tenían el OK con password anterior deben re-ingresar).
const STORAGE_KEY = 'limpack_beta_ok_v2'
// Password fuerte no-adivinable. Solo Nico/Roberto la usan via link del sidebar admin.
// Si se filtra, bumpear el sufijo numérico y avisar al equipo.
const BETA_PASSWORD = 'limpack-qa-mvd-7k9x'

/** Envuelve rutas públicas (/tienda, /suscribirme) durante el período beta cerrado.
 *  - Si URL trae ?beta=PASSWORD → setea localStorage y deja entrar
 *  - Si localStorage tiene la flag → deja entrar
 *  - Si no → muestra "Próximamente" con captura de email opcional
 *
 * IMPORTANTE: ?beta=ok ya NO funciona (era riesgo de seguridad — cualquiera lo adivinaba).
 * Solo el PASSWORD nuevo abre el bypass. */
const FLAG_CACHE_KEY = 'limpack_beta_cerrada_cache'
const FLAG_CACHE_TTL = 60_000  // 60s: evita golpear Supabase en cada navegación

export default function BetaGate({ children, origen = 'tienda' }) {
  const [params] = useSearchParams()
  // null = cargando el flag (no mostrar nada aún, evita flicker del ComingSoon).
  const [allowed, setAllowed] = useState(null)

  useEffect(() => {
    let cancel = false

    // ?beta=PASSWORD abre siempre (bypass), sin esperar el flag.
    if (params.get('beta') === BETA_PASSWORD) {
      try { localStorage.setItem(STORAGE_KEY, 'OK') } catch {}
      setAllowed(true)
      return
    }

    ;(async () => {
      // 1) Resolver flag app_config.beta_cerrada (cache 60s en sessionStorage).
      let cerrada
      try {
        const c = JSON.parse(sessionStorage.getItem(FLAG_CACHE_KEY) || 'null')
        if (c && (Date.now() - c.t) < FLAG_CACHE_TTL) cerrada = c.v
      } catch {}
      if (cerrada === undefined) {
        const { data } = await supabase
          .from('app_config').select('value').eq('key', 'beta_cerrada').maybeSingle()
        cerrada = data?.value === 'true' || data?.value === true || data?.value === '"true"'
        try { sessionStorage.setItem(FLAG_CACHE_KEY, JSON.stringify({ v: cerrada, t: Date.now() })) } catch {}
      }
      if (cancel) return

      // 2) Beta abierta → pasar siempre. Cerrada → lógica actual (localStorage o password).
      if (!cerrada) { setAllowed(true); return }
      let ok = false
      try { ok = localStorage.getItem(STORAGE_KEY) === 'OK' } catch {}
      setAllowed(ok)
    })()

    return () => { cancel = true }
  }, [params])

  if (allowed === null) return null   // cargando: no renderizar ComingSoon (parpadea feo)
  if (allowed) return children
  return <ComingSoon origen={origen} />
}

function ComingSoon({ origen }) {
  const [email, setEmail] = useState('')
  const [enviado, setEnviado] = useState(false)
  const [enviando, setEnviando] = useState(false)
  const [err, setErr] = useState(null)
  const [pwdInput, setPwdInput] = useState('')
  const [showPwd, setShowPwd] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setErr(null)
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) {
      setErr('Email inválido')
      return
    }
    setEnviando(true)
    try {
      const { error } = await supabase.rpc('agregar_lead_beta', {
        p_email: email.trim(), p_origen: origen,
      })
      if (error) throw error
      setEnviado(true)
    } catch (e) {
      setErr(e.message || 'Error desconocido')
    } finally { setEnviando(false) }
  }

  function handlePassword(e) {
    e.preventDefault()
    if (pwdInput.trim() === BETA_PASSWORD) {
      try { localStorage.setItem(STORAGE_KEY, 'OK') } catch {}
      window.location.reload()
    } else {
      setErr('Código incorrecto')
    }
  }

  return (
    <div style={shellStyle}>
      <main style={mainStyle}>
        <a href="https://limpack.uy" style={logoStyle}>
          Lim<span style={{ color: '#00A8B5' }}>pack</span>
        </a>
        <div style={cardStyle}>
          <div style={pillStyle}>🚧 Próximamente</div>
          <h1 style={h1Style}>Estamos preparando todo</h1>
          <p style={pStyle}>
            La tienda online de Limpack abre muy pronto. Si querés ser de los primeros en enterarte,
            dejanos tu email y te avisamos apenas lance.
          </p>

          {enviado ? (
            <div style={successStyle}>
              ✅ Listo. Te avisamos a <strong>{email}</strong> apenas abramos.
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ marginTop: 18 }}>
              <input
                type="email" required value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="tu@email.com"
                style={inputStyle}
                autoComplete="email"
              />
              {err && <div style={errStyle}>{err}</div>}
              <button type="submit" disabled={enviando} style={btnStyle}>
                {enviando ? 'Enviando…' : 'Avisame cuando abra →'}
              </button>
            </form>
          )}

          <div style={{ marginTop: 24, paddingTop: 18, borderTop: '1px solid rgba(255,255,255,.12)' }}>
            {!showPwd ? (
              <button onClick={() => setShowPwd(true)} style={linkBtn}>
                ¿Tenés código de acceso beta?
              </button>
            ) : (
              <form onSubmit={handlePassword} style={{ display: 'flex', gap: 8 }}>
                <input
                  type="password" value={pwdInput}
                  onChange={e => setPwdInput(e.target.value)}
                  placeholder="código"
                  style={{ ...inputStyle, flex: 1, marginBottom: 0 }}
                  autoFocus
                />
                <button type="submit" style={{ ...btnStyle, width: 'auto', padding: '12px 18px', marginTop: 0 }}>
                  Entrar
                </button>
              </form>
            )}
          </div>

          <div style={footStyle}>
            ¿Necesitás contactarnos? <a href="https://wa.me/59898610001" style={{ color: '#00A8B5', textDecoration: 'none' }}>WhatsApp 098 610 001</a>
          </div>
        </div>
      </main>
    </div>
  )
}

const shellStyle = {
  minHeight: '100vh', background: 'linear-gradient(135deg, #1A3461 0%, #1a3461 50%, #1a5cb8 100%)',
  display: 'flex', flexDirection: 'column', fontFamily: "'Inter', system-ui, sans-serif",
}
const mainStyle = { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }
const logoStyle = { color: '#fff', textDecoration: 'none', fontWeight: 800, fontSize: 28, marginBottom: 32 }
const cardStyle = { background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,255,255,.12)', borderRadius: 18, padding: 36, maxWidth: 480, width: '100%', backdropFilter: 'blur(12px)', color: '#fff' }
const pillStyle = { display: 'inline-block', background: 'rgba(0,196,212,.18)', color: '#7ce8f0', padding: '5px 14px', borderRadius: 999, fontSize: 11, fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 14 }
const h1Style = { margin: '0 0 12px', fontSize: 28, fontWeight: 900, letterSpacing: '-.02em', lineHeight: 1.15 }
const pStyle = { margin: 0, color: 'rgba(255,255,255,.75)', fontSize: 14, lineHeight: 1.55 }
const inputStyle = { width: '100%', boxSizing: 'border-box', padding: '12px 14px', fontSize: 14, border: '1.5px solid rgba(255,255,255,.18)', borderRadius: 10, background: 'rgba(0,0,0,.18)', color: '#fff', fontFamily: 'inherit', marginBottom: 12 }
const btnStyle = { width: '100%', padding: '14px 20px', fontSize: 14, fontWeight: 800, background: 'linear-gradient(135deg, #1a5cb8, #00A8B5)', color: '#fff', border: 0, borderRadius: 999, cursor: 'pointer', fontFamily: 'inherit', marginTop: 4, boxShadow: '0 6px 18px rgba(0,196,212,.3)' }
const linkBtn = { background: 'transparent', border: 0, color: 'rgba(255,255,255,.5)', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit', textDecoration: 'underline', padding: 0 }
const errStyle = { background: 'rgba(220,38,38,.15)', border: '1px solid rgba(252,165,165,.3)', color: '#fca5a5', padding: '8px 12px', borderRadius: 8, fontSize: 12, marginBottom: 10 }
const successStyle = { background: 'rgba(34,197,94,.15)', border: '1px solid rgba(134,239,172,.3)', color: '#86efac', padding: '14px 16px', borderRadius: 10, fontSize: 14, marginTop: 18, textAlign: 'center' }
const footStyle = { marginTop: 18, fontSize: 11, color: 'rgba(255,255,255,.45)', textAlign: 'center' }
